import { combineReducers, createStore, applyMiddleware } from "redux";
import userReducer from "./reducers/user";
import { thunk } from 'redux-thunk'; // Import named export 'thunk'

const rootReducer = combineReducers({
  user: userReducer,
});

const store = createStore(
  rootReducer,
  applyMiddleware(thunk) // Apply the 'thunk' middleware correctly
);

export default store;